module.exports = __webpack_public_path__ + "img/txt.eae03b1e.png";